import { render, staticRenderFns } from "./LabelLayoutEdit.vue?vue&type=template&id=17fcf9a8&scoped=true"
import script from "./LabelLayoutEdit.vue?vue&type=script&lang=ts"
export * from "./LabelLayoutEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fcf9a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17fcf9a8')) {
      api.createRecord('17fcf9a8', component.options)
    } else {
      api.reload('17fcf9a8', component.options)
    }
    module.hot.accept("./LabelLayoutEdit.vue?vue&type=template&id=17fcf9a8&scoped=true", function () {
      api.rerender('17fcf9a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/LabelLayoutEdit.vue"
export default component.exports